[
  {
    "dia": 15,
    "mupi": 1,
    "hora": "10h45min",
    "numero": 23,
    "titulo": "Influência da escola nas escolhas alimentares das crianças e dos pais - revisão narrativa",
    "autor": "Raquel Cavaco"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "10h52min",
    "numero": 24,
    "titulo": "Manifestações orais em crianças com patologia cardíaca congénita: Revisão Narrativa",
    "autor": "Matilde Veiga"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "10h59min",
    "numero": 25,
    "titulo": "Impact of Sodium Hypochlorite on the Chemical Composition of Coronal Dentin: A Literature Review",
    "autor": "Bianca Gomes"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "11h06min",
    "numero": 26,
    "titulo": "Alterações do microbioma oral na obesidade",
    "autor": "Joana Melo"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "11h13min",
    "numero": 27,
    "titulo": "Relação entre alterações salivares e a Síndrome Metabólica",
    "autor": "Juliana Soares"
  }
]